import { Modal } from '@enterprise-ui/canvas-ui-react'

export const UnrecognizedInputsModal = ({
  isVisible,
  onRefuse,
  errorStates,
  possibleFields,
}) => {
  return (
    <Modal
      headingText="Unrecognized Inputs"
      isVisible={isVisible}
      onRefuse={() => onRefuse()}
      size="dense"
      data-testid="unrecognized_inputs_modal"
    >
      <div className="hc-ph-lg hc-pb-lg">
        We didn't recognize the following inputs:
        {Object.keys(errorStates).map((fieldKey) => (
          <div key={`${fieldKey}_error_modal_container`}>
            <strong>{`${possibleFields[fieldKey].label}: `}</strong>
            {errorStates[fieldKey].join(', ')}
          </div>
        ))}
      </div>
    </Modal>
  )
}
